import axios from './axios';

export const fetchInbox = async (limit = 20, offset = 0) => {
    const params = new URLSearchParams({ limit: String(limit), offset: String(offset) });
    const response = await axios.get(`/messages?${params}`);
    return response.data;
};

export const fetchSent = async (limit = 20, offset = 0) => {
    const params = new URLSearchParams({ limit: String(limit), offset: String(offset) });
    const response = await axios.get(`/messages/sent?${params}`);
    return response.data;
};

export const fetchUnreadCount = async () => {
    const response = await axios.get('/messages/unread-count');
    return response.data.count;
};

export const markMessageAsRead = async (messageID) => {
    const response = await axios.patch(`/messages/${messageID}/read`);
    return response.data;
};

export const sendMessage = async ({ recipientUserID, subject, body }) => {
    const payload = { subject, body };
    if (recipientUserID) payload.recipientUserID = recipientUserID;
    const response = await axios.post('/messages', payload);
    return response.data;
};

export const broadcastMessage = async ({ subject, body }) => {
    const response = await axios.post('/messages/broadcast', { subject, body });
    return response.data;
};
